
  <ng-container *ngIf="exposure?.coverage.code !== '***No Claims Found***' ">
    <ng-container *ngIf="type === 'details'; else claimdashboard ">
      <ng-container *ngIf="exposure.exposureNumber.exposureNumber === claimid[1]">
        <div class="auto row no-margins-hug hug-content margin-top mt8">
          <div class="col-12 no-padding row">            
            <div class="col">
              <h2 class="claim-id margin-bottom mb4">{{ exposure?.coverage?.code | titlecase }} -
                <strong>{{claim?.number.number}}-{{ exposure?.exposureNumber?.exposureNumber }}</strong></h2>
              <div class="policy-id margin-bottom mb4">
                {{'AUTO' | translate | titlecase }} - <a
                  [routerLink]="['/my-insurance',  claim?.policyNumber.policyNumber, 'details']"><strong>{{ claim?.policyNumber.policyNumber }}</strong></a>
              </div>
              <div class="date-loss">
                {{ 'DATE_OF_LOSS' | translate }}: {{ claim?.date | customDateFormat }}
              </div>
            </div>
          </div>
          <hr class="claims-header-hr-margin w-100" />
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #claimdashboard>
    <div class="claim-item claim-home-item">
      <div class="claim-number">
        <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'AUTO'; else homeLogo">
          <ng-container *ngIf="isAcmic; else maCarIcon">
            <img src="./assets/img/images/icon-car-24.svg" alt="home icon" />
          </ng-container>
          <ng-template #maCarIcon>
            <img src="./assets/img/images/icon-car.svg" alt="car icon" />
          </ng-template>            
        </ng-container>
        <ng-template #homeLogo>
            <ng-container *ngIf="isAcmic; else maHomeIcon">
              <ng-container  *ngIf="claim?.propertyOrAutoIndicator === 'UMBRELLA'; else acmicHomeIcon" >
                <img src="./assets/img/images/icon-umbrella-acmic.svg" alt="umbrella icon" />
              </ng-container>
              <ng-template #acmicHomeIcon>
                <img src="./assets/img/images/icon-home-24.svg" alt="home icon" />
              </ng-template>
            </ng-container>
            <ng-template #maHomeIcon>
              <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'HOME'; else otherPolicyIcon">

                <img src="./assets/img/images/icon-home.svg" alt="home icon" />
              </ng-container>
              <ng-template #otherPolicyIcon>
                <div class="{{ claim?.propertyOrAutoIndicator | lowercase }}-class paperless-bg margin-right mr8 width-40 height-40"
                  *ngIf="claim?.propertyOrAutoIndicator!=='AUTO' && claim?.propertyOrAutoIndicator !== 'HOME' "></div>
              </ng-template>
            </ng-template>            
        </ng-template>
        <div class="claims-font ml-8" [ngClass]="{ 'ml-0': isAcmic }" > {{claim?.number?.number}} </div>
      </div>
      <div class="claim-info">
        <div class="claim-info-left">
          <div> {{ claim?.lossCause }} </div>
          <div class="policy-id margin-bottom mb4">
            <ng-container>
              <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'HOME' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER'">Personal</ng-container>
              {{claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' ? 'auto' : claim?.propertyOrAutoIndicator === 'HOME' ? 'property' : claim?.propertyOrAutoIndicator | translate | titlecase }} - {{ claim?.policyNumber?.policyNumber }}
            </ng-container>
          </div>
          <div class="date-loss">
           <span> {{ 'Date of loss' | translate }}:</span> {{ claim?.date | date:'MM/dd/yyyy' }}
          </div>
        </div>
        <div class="w-100-mobile">
          <a [routerLink]="['/claims', claim?.number.number, 'details']"
            class="claim-details-link w-100-mobile" mdbRipple>
            <span class="margin-right mr4">{{ 'DETAILS' | translate }}</span>
            <ng-container *ngIf="isAcmic; else maClaimLink">
              <svg-arror-right-svg></svg-arror-right-svg>
            </ng-container>
            <ng-template #maClaimLink>
              <img src="./assets/img/images/icon-arrow-right-white.svg" alt="right arrow" />
            </ng-template>            
          </a>
        </div>
      </div>
    </div>
  </ng-template>
